import { render } from "./MyRegisterBusiness.vue?vue&type=template&id=16b9d496"
import script from "./MyRegisterBusiness.vue?vue&type=script&lang=js"
export * from "./MyRegisterBusiness.vue?vue&type=script&lang=js"

import "./MyRegisterBusiness.vue?vue&type=style&index=0&id=16b9d496&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__